module.exports = __webpack_public_path__ + "static/img/yy.fe603a64.png";